// Import realtime helpers FIRST (before App / supabase consumers) so the
// global WebSocket filter and error shield are installed before any
// `.channel().subscribe()` call constructs a websocket. See
// `src/lib/realtime.ts` for the rationale.
import './lib/realtime';

import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Remove dark mode class addition
createRoot(document.getElementById('root')!).render(<App />);
